<custom-navbar barTitle="설정" [showSetting]="false"></custom-navbar>
<div class="setting-wrap">
  <div class="setting-list">
    <div class="setting-list-title">고객 지원</div>
    <div class="setting-list-item" (click)="goNotice()">
      <div class="setting-label notice">
        공지사항
        <div class="setting-new-icon" *ngIf="notice.hasNew()">N</div>
      </div>
    </div>
  </div>

  <div class="setting-list">
    <div class="setting-list-title">회원 정보</div>
    <div class="setting-list-item">
      <div class="setting-label">자동로그인</div>
      <mat-slide-toggle
        [(ngModel)]="autoLogin"
        (change)="changeAutoLogin()"
        color="warn"></mat-slide-toggle>
    </div>
    <div class="setting-list-item" (click)="logout()">로그아웃</div>
    <div class="setting-list-item" (click)="changePwd()">비밀번호 변경</div>
  </div>

  <div class="setting-list">
    <div class="setting-list-title">예약 알림</div>
    <div class="setting-list-item">
      <div class="setting-label">알림끄기</div>
      <mat-slide-toggle
        [checked]="alarmToggle"
        [disabled]="!alarmToggle"
        (change)="clearAlarms()"
        color="warn">
      </mat-slide-toggle>
    </div>
    <div class="setting-list-item" *ngFor="let alarm of alarmList">
      <div class="setting-label">{{alarm.minute | timeTransfer}} 전 알림</div>
      <mat-slide-toggle
        [(ngModel)]="alarm.active"
        (change)="changeAlarm(alarm)"
        color="warn"></mat-slide-toggle>
    </div>
  </div>

  <div class="setting-list">
    <div class="setting-list-title">자녀 변경하기</div>
    <div
      class="setting-list-item"
      *ngFor="let data of childrenList"
      (click)="changeChild(data.num)">
      <div class="setting-label">
        {{data.name}}
        <span *ngIf="chooseChild == data.num" class="setting-child-selected">자녀 선택됨</span>
      </div>
      <div class="select-child-icon" [ngClass]="{ 'checked' : chooseChild == data.num }"></div>
    </div>
  </div>

  <div class="setting-bottom">
    Balance Brain Customer service<br>
    Ver 2.0.2.1<br>
    Copyright (c) 2017 PDR All Right reserved.
  </div>
</div>
